<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import GroupList from './GroupList'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    GroupList,
  },
  computed: {
    title() {
      return this.$t('setting.list.userSetting.pengaturanPengguna')
    },
    subTitle() {
      return this.$t('setting.list.userSetting.textPengguna')
    },
    breadcrumbItems() {
      return [
        {
          text: this.$t('setting.homePage.pengaturan'),
          to: '/setting',
        },
        {
          text: this.$t('setting.list.userSetting.pengaturanPengguna'),
        },
      ]
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :subTitle="subTitle"
      :items="breadcrumbItems"
      hasBreadcrumb
      hasBackButton
    />

    <form>
      <b-card class="mc-card__setting">
        <b-tabs content-class="p-3 text-muted" nav-wrapper-class="mc-tab">
          <GroupList />
        </b-tabs>
      </b-card>
    </form>
  </Layout>
</template>
